import {useQuery} from "@apollo/client";
import * as Sentry from "@sentry/react";
import {PropsWithChildren, createContext} from "react";

import {DEFAULT_PUBLIC_USER_CONTEXT, getPublicUserContext} from "@/components/context/utils.ts";
import {CurrentUserContext, GQL_USER_CONTEXT} from "@/lib/queries/accounts.ts";
import {DateFormatName, TimeFormatName} from "@/lib/types/common.ts";

export interface PublicUserContext extends CurrentUserContext {
  timezone: string;
  currentDateFormat: DateFormatName;
  currentTimeFormat: TimeFormatName;
  getShortDateTime: (date: string) => string;
  userHasFeature: (name: string) => {};
}

export const PublicUserContext = createContext<PublicUserContext>(DEFAULT_PUBLIC_USER_CONTEXT);

export const PublicUserContextProvider = ({children}: PropsWithChildren) => {
  const {data} = useQuery<CurrentUserContext>(GQL_USER_CONTEXT, {context: {skipAuthError: true}});

  const user = data?.user;
  if (user) {
    Sentry.setUser({accountuser_id: user.id, account_id: user.account?.id});
  }

  return <PublicUserContext.Provider value={getPublicUserContext(data)}>{children}</PublicUserContext.Provider>;
};
